// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3jaSj","requiredAsterisk":"Info_requiredAsterisk__13uWO"};